<template>
	<div>
		<SOLoadingPage v-if="pageSetting.loading"/>

		<!--<div class="vh-100 bg-white p-d-72" v-else>-->
		<div class="vh-100 bg-white" v-else>
			<SOTitleBar
				:page-title="'Detail Konsumen'"
				:type="'back'"
				:show-search="false"
				@back="back"
			/>
			<div class="content-wrapper main-page showPageDefault">
				<div class="p-x-20 p-y-8 bg-grey">
					<div class="f-regular f-12 f-c-midgrey">
						Terdaftar sejak {{ customer.terdaftar }}
					</div>
				</div>
				<div class="p-x-20 p-y-12">
					<div class="d-flex justify-content-between">
						<div class="f-16 f-c-text-primary p-d-8">
							Informasi Konsumen
						</div>
						<div @click="$router.push({ name: 'customerEdit', params: { id: idcustomer} })">
							<SOIconBase view-box="0 0 20 21" width="20" height="21">
								<template v-slot:icon>
									<EditPencil2021 />
								</template>
							</SOIconBase>
						</div>
					</div>
					<div
						v-for="(item, index) in informasiKonsumen"
						:key="index"
						class="f-12 f-c-midgrey d-flex"
						style="padding: 1px 0"
					>
						<div 
							style="min-width: 120px"
						>
							{{ item.title }}
						</div>
						<span class="p-x-8">
							:
						</span>
						<span :class="index == 4 ? 'f-c-primary-product-dark' : 'f-c-text-primary'">
							<span class="f-c-midgrey" v-if="item.index == 2">
								{{ item.sapaan + ' ' }}
							</span>
							{{ item.value }}
						</span>
					</div>
				</div>

				<div class="separator"></div>

				<SOMenuItemRegular
					:title="'Daftar Alamat'"
					:show-subtitle="true"
					:subtitle="(customer.jumlah_alamat !== 0) ? formatRupiah(customer.jumlah_alamat) + ' Alamat terdaftar' : 'Tidak ada alamat terdaftar'"
					class="border-bottom"
					@detail="detailAlamat"
				/>
				<SOMenuItemRegular
					:title="'Transaksi Reguler & Deposit'"
					:show-subtitle="true"
					:subtitle="(customer.jumlah_transaksi !== 0) ? formatRupiah(customer.jumlah_transaksi) + ' Transaksi (total)' : 'Tidak ada transaksi'"
					class="border-bottom"
					@detail="detailTransaksiKonsumen"
				/>
				<SOMenuItemRegular
					v-if="false"
					:title="'Transaksi SnapClean'"
					:show-subtitle="true"
					:subtitle="'Tidak ada transaksi'"
					class="border-bottom"
					@detail="detailTransaksiKonsumen"
				/>
				<SOMenuItemRegular
					:title="'Paket Deposit'"
					:show-subtitle="true"
					:subtitle="(customer.jumlah_paket_deposit !== 0) ? formatRupiah(customer.jumlah_paket_deposit) + ' Paket Aktif' : 'Tidak ada paket deposit'"
					class="border-bottom"
					@detail="detailPaketDepositKonsumen"
				/>
				<SOMenuItemRegular
					:title="'E-payment'"
					:show-subtitle="true"
					:subtitle="(customer.jumlah_emoney !== 0) ? 'Sisa ' + formatRupiah(customer.jumlah_emoney) : 'Tidak memiliki emoney'"
					class="border-bottom"
					@detail="detailEmoneyKonsumen"
				/>
				<SOMenuItemRegular
					v-if="isWebview()"
					title="Riwayat Pendaftaran Member"
					:show-subtitle="true"
					:subtitle="`${customer.member_registration_tx.all} Transaksi Pendaftaran Member`"
					class="border-bottom"
					@detail="riwayatPendaftaranMember()"
				/>

				<div class="separator"></div>

				<SOMenuItemIcon
					v-if="topFive.data.rank_layanan.length > 0 && validateAccess('customerRegular.read')"
					class="border-bottom"
					:title="'Layanan Terfavorit'"
					:subtitle="'Layanan yang sering digunakan'"
					:show-subtitle="true"
					:icon-favorite="true"
					@action="detailLayananFavorit"
				/>

				<SOMenuItemIcon
					v-if="validateAccess('customerRegular.read')"
					class="border-bottom"
					:title="'Riwayat Perubahan Data'"
					:icon-history="true"
					@action="riwayatPerubahanData"
				/>

				<div class="separator" v-if="topFive.data.rank_layanan.length > 0"></div>

				<SOMenuItemIcon
					v-if="validateAccess('customerRegular.delete')"
					:title="'Hapus Konsumen'"
					:icon-trash="true"
					@action="() => { pageSetting.modal.hapus = true }"
				/>
			</div>

			<!-- modals -->
			<CustomerModalUbahOutlet
				v-if="pageSetting.modal.outlet"
				@close="() => { pageSetting.modal.outlet = false }"
			/>
			<CustomerModalUbahNama
				v-if="pageSetting.modal.nama"
				@close="() => { pageSetting.modal.nama = false }"
			/>
			<CustomerModalUbahJenisKelamin
				v-if="pageSetting.modal.jenisKelamin"
				@close="() => { pageSetting.modal.jenisKelamin = false }"
			/>
			<CustomerModalUbahTelepon
				v-if="pageSetting.modal.telepon"
				@close="() => { pageSetting.modal.telepon = false }"
			/>
			<CustomerModalUbahInstansi
				v-if="pageSetting.modal.instansi"
				@close="() => { pageSetting.modal.instansi = false }"
			/>
			<CustomerModalUbahTanggalLahir
				v-if="pageSetting.modal.tanggalLahir"
				@close="() => { pageSetting.modal.tanggalLahir = false }"
			/>
			<CustomerModalUbahAgama
				v-if="pageSetting.modal.agama"
				@close="() => { pageSetting.modal.agama = false }"
			/>
			<CustomerModalUbahEmail
				v-if="pageSetting.modal.email"
				@close="() => { pageSetting.modal.email = false }"
			/>

			<CustomerModalHapus
				v-if="pageSetting.modal.hapus"
				@close="() => { pageSetting.modal.hapus = false }"
				:customer="customer"
			/>
		</div>
	</div>
</template>

<script>
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";

import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
import SOMenuItemEdit from "@/so-components/global/ui/SOMenuItemEdit";
import SOMenuItemRegular from "@/so-components/global/ui/SOMenuItemRegular";
import SOMenuItemIcon from "@/so-components/global/ui/SOMenuItemIcon";

import CustomerModalUbahOutlet from "./modal/CustomerModalUbahOutlet";
import CustomerModalUbahNama from "./modal/CustomerModalUbahNama";
import CustomerModalUbahJenisKelamin from "./modal/CustomerModalUbahJenisKelamin";
import CustomerModalUbahTelepon from "./modal/CustomerModalUbahTelepon";
import CustomerModalUbahInstansi from "./modal/CustomerModalUbahInstansi";
import CustomerModalUbahTanggalLahir from "./modal/CustomerModalUbahTanggalLahir";
import CustomerModalUbahAgama from "./modal/CustomerModalUbahAgama";
import CustomerModalUbahEmail from "./modal/CustomerModalUbahEmail";
import CustomerModalHapus from "./modal/CustomerModalHapus";
import SOIconBase from "@/so-components/global/icons/SOIconBase.vue";
import EditPencil2021 from "@/so-components/global/icons/iconPacks/EditPencil2021.vue";

import {mapGetters} from "vuex"

export default {
	name: "CustomerDetail",
	components: {
		SOLoadingPage,

		SOTitleBar,
		SOMenuItemEdit,
		SOMenuItemRegular,
		SOMenuItemIcon,

		CustomerModalUbahOutlet,
		CustomerModalUbahNama,
		CustomerModalUbahJenisKelamin,
		CustomerModalUbahTelepon,
		CustomerModalUbahInstansi,
		CustomerModalUbahTanggalLahir,
		CustomerModalUbahAgama,
		CustomerModalUbahEmail,
		CustomerModalHapus,
		SOIconBase,
		EditPencil2021,
	},
	computed: {
		...mapGetters("customerModule", {
			customer: "getDetailCustomer",
			topFive: "getTopFive",
		}),
		...mapGetters("metaModule", {
			sapaan: "getSapaan",
			agama: "getAgama",
		}),
		informasiKonsumen() {
			let customer = this.customer;
			let sapaan = this.sapaan;
			return [
				{
					title: 'Terdaftar di Outlet',
					value: customer.nama_outlet,
				},
				{
					title: 'Nama',
					value: customer.nama_customer,
					sapaan: (customer.sapaan === 0) ? customer.nama_customer : sapaan[sapaan.findIndex((a) => a.id === customer.sapaan)].text,
				},
				{
					title: 'Jenis Kelamin',
					value: (customer.jenis_kelamin == 1) ? 'Laki-laki' : 'Perempuan',
				},
				{
					title: 'Nomor Telepon',
					value: (customer.phone !== '') ? customer.country_code + customer.phone : 'Belum diatur',
				},
				{
					title: 'Jenis Member',
					value: (customer.member_name || 'Belum diatur')
				},
				{
					title: 'Instansi',
					value: (customer.instansi !== '') ? customer.instansi : 'Belum diatur',
				},
				{
					title: 'Tanggal Lahir',
					value: (customer.tanggal_lahir_formated !== '') ? customer.tanggal_lahir_formated : 'Belum diatur',
				},
				{
					title: 'Agama',
					value: (!customer.agama) ? 'Belum diatur' : this.agama.find(agama => agama.id === customer.agama).text,
				},
				{
					title: 'Email',
					value: (customer.email !== '') ? customer.email : 'Belum diatur',
				},
			];
		}
	},
	data() {
		return {
			idcustomer: "",

			pageSetting: {
				loading: true,
				rotateBtn: {
					rotate: false
				},
				modal: {
					outlet: false,
					nama: false,
					jenisKelamin: false,
					telepon: false,
					instansi: false,
					tanggalLahir: false,
					agama: false,
					email: false,
					hapus: false,
				}
			},
			routeFromCreate: false,
		}
	},
	beforeRouteEnter(to, from, next) {
		next(vm => {
			if (from.name === "customerCreateStep2") vm.routeFromCreate = true
		})
	},
	mounted() {
		this.idcustomer = this.$route.params.id
		this.getSapaan()
		this.getAgama()
		this.fetchDetailCustomer(this.idcustomer)
		this.fetchTopFiveLayanan(this.idcustomer)
		this.smartTrackingView("detail_konsumen_reguler");

	},
	methods: {
		async back() {
			if (this.routeFromCreate) {
				await this.$store.commit("customerModule/resetPagination")
				await this.$store.commit("customerModule/resetCustomer")
				await this.$store.commit("customerModule/resetDetailCustomer")
				await this.$router.push("/konsumen")
			} else {
				this.$router.back()
			}
		},
		showMoreDetail() {
			$("#more-detail").slideToggle();
			let deg180 = {"transform": "rotate(180deg)"};
			let deg0 = {"transform": "rotate(0deg)"};
			this.pageSetting.rotateBtn.rotate ? $('#chev-more-detail').css(deg0) : $('#chev-more-detail').css(deg180);
			this.pageSetting.rotateBtn.rotate = !this.pageSetting.rotateBtn.rotate;
		},
		async getSapaan() {
			const res = await this.$store.dispatch("metaModule/fetchSapaan")
			if (!res.success) {
				this.$toast.error(res.err)
			}
		},
		async getAgama() {
			const res = await this.$store.dispatch("metaModule/fetchAgama")
			if (!res.success) {
				this.$toast.error(res.err)
			}
		},
		async fetchDetailCustomer(idcustomer) {
			this.pageSetting.loading = true
			const res = await this.$store.dispatch("customerModule/fetchDetailCustomer", idcustomer)
			this.pageSetting.loading = false
			if (!res.success) {
				this.$toast.error(res.err)
			}
		},
		async fetchTopFiveLayanan(idcustomer) {
			const res = await this.$store.dispatch("customerModule/fetchTopFive", idcustomer)
			if (!res.success) {
				this.$toast.error(res.err)
			}
		},

		detailAlamat() {
			this.$router.push("/konsumen/alamat/" + this.idcustomer)
			this.smartTrackingClick("alamat_konsumen_reguler");

		},
		detailTransaksiKonsumen() {
			this.$router.push("/konsumen/detail/transaksi/" + this.idcustomer)
			this.smartTrackingClick("transaksi_konsumen_reguler");
		},
		detailPaketDepositKonsumen() {
			this.$router.push("/konsumen/detail/paket_deposit/" + this.idcustomer)
			this.smartTrackingClick("paket_deposit_konsumen_reguler");
		},
		detailEmoneyKonsumen() {
			this.$router.push("/konsumen/detail/epayment/" + this.idcustomer)
			this.smartTrackingClick("paket_emoney_konsumen_reguler");
		},
		detailTransaksiSnapcleanKonsumen() {
			this.$router.push("/konsumen/detail/transaksi_snapclean/" + this.idcustomer)
		},
		detailLayananFavorit() {
			this.$router.push("/konsumen/detail/top_five/" + this.idcustomer)
			this.smartTrackingClick("layanan_favorit_konsumen_reguler");
		},
		riwayatPerubahanData() {
			this.$router.push({name: "CustomerRiwayatPerubahan", params: { idcustomer: this.idcustomer }})
			this.smartTrackingClick("riwayat_perubahan_konsumen_reguler");
		},
		riwayatPendaftaranMember() {
			this.flutterNavigate(`member/history/list?idcustomer=${this.customer.idcustomer}&nama=${this.customer.nama_customer}`);
		}
	}
}
</script>